import { withBlockingErrorBoundary } from '@edreamsodigeo/frontend-core';

import { BrokenFlowErrorModal as ErrorModal } from '#src/components/Common/ErrorModal';
import { withAdditionalProductsContext } from 'clientState/hocs/withAdditionalProductContext';
import {
  PostBookingBuyerProvider as AdditionalProductsPostBookingBuyerProvider,
  TripProvider as AdditionalProductsTripProvider,
} from 'clientState/providers';

export * from './PostBookingFunnel';
export * from './SmokeTest';
export {
  useHasInsurances,
  useNextItineraryFunnelPage,
  useTrip,
} from 'clientState/hooks';

export const BrokenFlowErrorModal = withAdditionalProductsContext(ErrorModal);

export const PostBookingBuyerProvider = withBlockingErrorBoundary(
  AdditionalProductsPostBookingBuyerProvider,
  { name: 'AdditionalProductsPostBookingBuyerProvider' },
);

export const TripProvider = withBlockingErrorBoundary(
  withAdditionalProductsContext(AdditionalProductsTripProvider),
  { name: 'AdditionalProductsTripProvider' },
);

export * from '#src/components/Common/SidebarServicesSection';
export * from '#src/components/Common/HeaderBackground';
